import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Seo title="页面不存在 - 卡通动漫第一页" description="你要访问的页面不存在，返回卡通动漫第一页继续浏览今日更新与热门榜单。" />
      <Navbar />
      <main className="flex min-h-[70vh] flex-col items-center justify-center gap-5 bg-background-50 px-4 pt-16 text-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-600">
          <i className="ri-emotion-sad-line" style={{ fontSize: "40px" }}></i>
        </span>
        <h1 className="font-display text-4xl text-foreground-950">页面走丢了</h1>
        <p className="max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的页面不存在或已被移除，不如去今日更新、热门榜单和编辑推荐逛逛，说不定能找到新的心头好。
        </p>
        <div className="mt-2 flex flex-col gap-3 sm:flex-row">
          <Link to="/" className="rounded-full bg-primary-500 px-7 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 hover:bg-primary-600 transition-colors">返回首页</Link>
          <Link to="/today" className="rounded-full bg-background-100 px-7 py-2.5 text-sm font-medium whitespace-nowrap text-foreground-800 ring-1 ring-background-200 hover:bg-background-200 transition-colors">去看今日更新</Link>
        </div>
      </main>
      <Footer />
    </>
  );
}